import { useState, useEffect } from "react";

/*
 * Custom Hook to manage localStorage with React state
 * @param key - The key to store in localStorage
 * @param initialValue - Default value if no key is found
 * @returns [storedValue, setStoredValue] - Value and setter function
 */
const useLocalStorage = (key: string, initialValue: string | null) => {
  const [storedValue, setStoredValue] = useState<string | null>(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? item : initialValue;
    } catch (error) {
      console.error("Error accessing localStorage:", error);
      return initialValue;
    }
  });

  // Update localStorage whenever `storedValue` changes
  useEffect(() => {
    if (storedValue !== null) {
      localStorage.setItem(key, storedValue);
    } else {
      localStorage.removeItem(key); // Remove if null
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue] as const;
};

export default useLocalStorage;
